var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon-component",class:_vm.iconClasses,style:(_vm.iconStyles)},[(_vm.iconExists && _vm.svgContent)?_c('span',{staticClass:"icon-svg",domProps:{"innerHTML":_vm._s(_vm.svgContent)}}):_c('span',{staticClass:"icon-fallback"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }